<!-- Hero Section -->
<section class="contact-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <h1 class="hero-title">Connect with Us</h1>
    <p class="hero-subtitle">Need help with a booking or interested in becoming a verified Guide?</p>
    <p class="hero-subtitle-secondary">We're here to help you experience the world better.</p>
  </div>
</section>

<!-- Contact Information Section -->
<section class="contact-info-section">
  <div class="contact-card">
    <div class="contact-info-grid">
      <!-- Urgent Support -->
      <div class="contact-item">
        <div class="icon-wrapper">
          <img src="assets/ContactUs/calling.svg" alt="Phone Icon" class="contact-icon" />
        </div>
        <h3 class="contact-title">URGENT SUPPORT</h3>
        <p class="contact-description">
          For urgent booking issues or on-the-ground traveler support, call our dedicated hotline.
        </p>
        <a href="tel:+971563306574" class="contact-link">+971 56 330 6574</a>
      </div>

      <!-- Guide & Partner Inquiries -->
      <div class="contact-item">
        <div class="icon-wrapper">
          <img src="assets/ContactUs/MailBox.svg" alt="Email Icon" class="contact-icon" />
        </div>
        <h3 class="contact-title">GUIDE & PARTNER INQUIRIES</h3>
        <p class="contact-description">
          For guide applications, partnership requests, or business queries, email our team directly.
        </p>
        <a href="mailto:info@safroo.com" class="contact-link">info@safroo.com</a>
      </div>
    </div>
  </div>
</section>
